// extracted by mini-css-extract-plugin
module.exports = {"market":"index_market__Qka9V","market_loading":"index_market_loading__An6qN","wrapper":"index_wrapper__m_gxF"};